export const config = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || 'https://aivitahelper.xyz:8081',
  apiPrefix: process.env.VUE_APP_API_PREFIX || '/api'
};

export const getApiUrl = (path: string) => {
  return `${config.apiBaseUrl}${config.apiPrefix}${path}`;
};

export default config; 